// import { makeStyles } from '@material-ui/core/styles';
// import classnames from 'classnames';
import {  TextField } from 'react-admin';


export const ColoredChipFieldStatus = props => {
  let userId = localStorage.getItem("userId")
  const unread = props.record.users.find(a => a.userId === userId).unread;
 
  return (
    <TextField
      style={{
        backgroundColor: unread ? '#f26666' : '#66f26f',
        'width': '5px',
        'height': '50px',
        'display': '-webkit-box'
      }}
      {...props}
    />
  );
};
